import React, { useEffect, useState } from "react";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import { toast } from "react-toastify";
import moment from "jalali-moment";
import { useForm } from "react-hook-form";

// JS Files
import MuiTextField from "../shares/MuiTextField";
import MuiButton from "../shares/MuiButton";
import useFetch from "../../context/useFetch";

// Others File
import noDataIcon from "../../imgs/no-data.svg";
import NewRequest from "./NewRequest";
import { fixNumbers } from "../../Utils";

const FollowupForm = () => {
  const [code, setCode] = useState();
  const [answer, setAnswer] = useState(undefined);
  const [caseId, setCaseId] = useState();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
  } = useForm();

  const [enterCaptchaValue, setEnterCaptchaValue] = useState("");
  const [captchaData, setCaptchaData] = useState({
    captcha_image: "",
    captcha_key: "",
  });
  const captchaApi = useFetch({
    method: "post",
    url: "api/captcha",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setCaptchaData(res);
      setEnterCaptchaValue("");
    },
    errMessage: (mess) => {
      toast.error("دوباره تلاش کنید ", {
        position: toast.POSITION.TOP_CENTER,
      });
      captchaApi.reFetch();
    },
  });

  const getCaseStatus = useFetch({
    method: "post",
    url: `Case_Service/check_case_status`,
    noHeader: true,
    trigger: false,
    data: {
      code: fixNumbers(code),
      captcha_value: enterCaptchaValue,
      captcha_key: captchaData.captcha_key,
    },
    argFunc: (res) => {
      if (res.data == "code_is_required") {
        toast.error("کد رهگیری را وارد نمایید", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else if (res.data == "code_not_found") {
        toast.error("کد رهگیری مورد نظر یافت نشد", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else if (res.data == "no_answer") {
        setAnswer("no_answer");
      } else {
        setAnswer(res.data);
        setCaseId(res.id);
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
      captchaApi.reFetch();
    },
  });

  return (
    <>
      <div className="border rounded-lg mt-8 border-mygray-300 py-8 px-4">
        <div className="grid md:grid-cols-3 items-center ">
          <div className="border-r-4 col-span-3 border-mygray-300 px-4">
            <span className="text-sm md:text-base font-bold text-mygray-700">
              کاربر گرامی جهت پیگیری پرونده خود کد رهگیری را وارد نمایید.
            </span>
          </div>
          <div className="mt-4 md:mt-0 col-span-3 md:col-span-1">
            <MuiTextField
              isLTR={true}
              id="code"
              label="کد رهگیری"
              variant="outlined"
              size="small"
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
          <div className=" flex justify-center col-span-3 md:col-span-1 mt-4 md:mt-0">
            <img
              className="w-36 h-24 md:w-48 md:h-24"
              src={`data:image/png;base64,${captchaData.captcha_image}`}
            />
          </div>

          <div className="col-span-3 md:col-span-1 mt-4 md:mt-0">
            <MuiTextField
              value={enterCaptchaValue}
              onChange={(e) => setEnterCaptchaValue(e.target.value)}
              id="outlined-basic"
              label="کد تصویری امنیتی"
              variant="outlined"
              size="small"
              name="captcha"
              isLTR
              type="captcha"
              control={control}
              register={{
                required: {
                  value: true,
                  message: "کد تصویری امنیتی را وارد کنید",
                },
              }}
            />
          </div>
          <div className="mt-4 md:mt-0 col-span-3 md:mr-12 text-center md:text-left">
            <MuiButton
              disabled={enterCaptchaValue === ""}
              onClick={() => {
                setAnswer(undefined);
                getCaseStatus.reFetch();
              }}
              type="submit"
              variant="contained"
              color="primary"
              text="پیگیری"
            />
          </div>
        </div>
      </div>
      <div className="border rounded-lg mt-8 border-mygray-300 py-8 px-4">
        {answer == undefined ? (
          <div className="flex justify-center items-center">
            <img src={noDataIcon} />
          </div>
        ) : (
          <>
            <div className=" border-r-4 border-mygray-300 px-4">
              <span className="text-sm md:text-base font-bold text-mygray-700">
                وضعیت پرونده شما
              </span>
            </div>
            {answer.length <= 1 ? (
              <p className="text-sm md:text-base mt-8 text-mygray-700">
                پرونده شما در دست بررسی می‌باشد، از صبوری شما متشکریم!
              </p>
            ) : (
              <>
                <div className="flex flex-col overflow-scroll max-h-96 m-4 px-1">
                  {answer.map((item, index) => {
                    return (
                      <>
                        {item.from_admin ? (
                          <>
                            <div className="bg-orange-50 rounded-md p-4 w-2/3 my-1 self-end">
                              <div className="flex justify-between items-center mb-4">
                                <span className="font-bold">پاسخ:</span>
                                <div className="text-sm">
                                  <span className="mr-4">
                                    تاریخ:{" "}
                                    {moment(item.created_at, "YYYY/MM/DD")
                                      .locale("fa")
                                      .format("YYYY/MM/DD")}
                                  </span>
                                </div>
                              </div>
                              <p>{item.description}</p>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="bg-cyan-50 rounded-md p-4 w-2/3 my-1 ">
                              <div className="flex justify-between items-center mb-4">
                                <span className="font-bold">درخواست:</span>
                                <span className="text-sm">
                                  تاریخ:{" "}
                                  {moment(item.created_at, "YYYY/MM/DD")
                                    .locale("fa")
                                    .format("YYYY/MM/DD")}
                                </span>
                              </div>
                              <p>{item.description}</p>
                              {item.attach_file !== "EMPTY" && (
                                <div className="mt-4 text-sm  flex items-center">
                                  <span>دانلود مدارک:</span>
                                  <div className="transition-all hover:scale-125  text-pink-700">
                                    <a
                                      className="mr-4 cursor-pointer"
                                      target="_blank"
                                      download
                                      href={item.attach_file}
                                    >
                                      <FolderZipIcon className="" />
                                    </a>
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </>
                    );
                  })}
                </div>
                <NewRequest caseId={caseId} api={getCaseStatus} />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default FollowupForm;
